'use strict';

import SearchRoute from './SearchRoute';

export default function SearchRoutes({ 
    type, 
    routes = [], 
    onlyAirports = false,
    maxAirports,
    airports,
    requestMode = false,
    maxRoutes = 5,
    errors: userErrors, 
    containerClass: userContainerClass,
    dropDownParent,
    isOpenedInit = true,
    onIsOpenedChange,
    onFocus,
    onSearch, 
    onChangeRoutes,
}) {
    const SLIDER = {
        CONTAINER_WIDTH: 960,
        SPACE_BETWEEN: 10,
        SLIDE_WIDTH: 232,
    }
    
    const [isOpened, setIsOpened] = React.useState(true);
    const [stateErrors, setStateErrors] = React.useState([]);
    const containerRef = React.useRef()
    
    React.useEffect(() => {
        if (routes.length > 1)
            setIsOpened(isOpenedInit);
    }, [ isOpenedInit ])

    React.useEffect(() => {
        onIsOpenedChange && onIsOpenedChange(isOpened) 
    }, [ isOpened ])
    
    const errors = [...(Array.isArray(userErrors) ? userErrors : []), ...(stateErrors || [])]

    const addRoute = (e, backRoute = null) => {
        e.preventDefault();

        let newRoutes = [...routes];
        if(newRoutes.length >= maxRoutes) return;

        let route = {from: {}, to: {}, date: '', time: '', seats: 0}
        if(backRoute !== null) {
            route = {
                ...newRoutes[backRoute],
                from: newRoutes[backRoute].to,
                to: newRoutes[backRoute].from,
                date: '',
                time: '',
                seats: 0,
            };
        }

        newRoutes.push(route);
        onChangeRoutes && onChangeRoutes(newRoutes);
    }

    const removeRoute = (e, index) => {
        e.preventDefault();
        let newRoutes = [...routes];
        onChangeRoutes && onChangeRoutes(routes.filter((r, i) => i !== index));
    }

    const handleChangeRoute = (index, route) => {
        let newRoutes = [...routes];
        newRoutes[index] = route;
        onChangeRoutes && onChangeRoutes(newRoutes);
    }

    const getRoutes = () => {
        return  ['planes', 'plane'].includes(type) ? routes : routes.slice(0, 1);
    }

    const validate = () => {
        let errors = [];
        let hasErrors = false
        routes.map((route, index) => {
            errors.push([]);
            if (!route.from.id) errors[index].push('from');
            if (!route.to.id) errors[index].push('to');
            if (!route.date) errors[index].push('date');
            if (type === 'planes') {
                if (!route.time) errors[index].push('time');
                if (!route.seats) errors[index].push('seats');
            }
            if (errors[index].length > 0) hasErrors = true;
        })
        
        setStateErrors(errors);
        return !hasErrors;
    }

    const handleSearch = () => {
        if (validate()) {
            if (routes.length > 1)
                setIsOpened(false)
            onSearch && onSearch()
        }
    }

    React.useEffect(() => {
        if (containerRef.current && !isOpened) {
            new Swiper(containerRef.current, {
                slidesPerView: 'auto',
                spaceBetween: SLIDER.SPACE_BETWEEN,
                freeMode: true,
                allowTouchMove: (routes.length > 4),
            });
            
        }
    }, [ routes, isOpened ])

    if (!requestMode && !isOpened && type === 'planes') {
        
        let slideWidth = SLIDER.SLIDE_WIDTH;
        
        if (routes.length <= 4) {
            const totalSpaces = SLIDER.SPACE_BETWEEN * Math.max(0, routes.length - 1);
            slideWidth = Math.floor((SLIDER.CONTAINER_WIDTH - totalSpaces) / routes.length) - 1;
        }
        
        return <div className="direction-selected">
            <div ref={containerRef} className="swiper">
                <div className="swiper-wrapper">
                    
                    {routes.map((item, index) => {
                        
                        const itemDate = window.moment ? moment((item.date), 'DD.MM.YYYY').format("D MMMM") : item.date;
                        
                        return <div key={`formRoutes${index}`} className="swiper-slide" style={{width: `${slideWidth}px`, userSelect:'none', cursor: routes.length <= 4 ? 'auto' : 'grab'}}>
                            <div className={cn("direction-card", routes.length >=4 && "direction-four")}>
                                <div className="direction-card__info">
                                    <span>
                                        <i className="icon-calendar2"></i>
                                        {itemDate}
                                    </span>
                                    <span>
                                        <i className="icon-time2"></i>
                                        {item.time}
                                    </span>
                                    <span>
                                        <i className="icon-user"></i>
                                        {item.seats}
                                    </span>
                                </div>
                                <div className="direction-card__way">
                                    <div className="direction-card__code">{item.from.icao}</div>
                                    <div className="direction-card__line">
                                        <span></span>
                                        <div className="solid-left"></div>
                                        <i className="icon-plane2"></i>
                                        <div className="solid-right"></div>
                                        <span></span>
                                    </div>
                                    <div className="direction-card__code">{item.to.icao}</div>
                                </div>
                            </div>
                        </div>
                    })}
                </div>
            </div>
            <div className="direction-selected__btn" style={{cursor:'pointer'}}>
                <a type="button" className="direction-selected__edit" onClick={() => setIsOpened(true)}>
                    <i className="icon-edit"></i>
                    {tMsg('Изменить')}
                </a>
            </div>
        </div>
    }

    let containerClass = ['search', userContainerClass]
    if (type === 'sharing') containerClass.push('request-sharing')
    if (type === 'emptyleg') containerClass.push('request-el')

    return <div className={containerClass.join(' ')}>
        {getRoutes().map((route, index) => <SearchRoute
            key={index}
            type={type}
            dateRange={type === 'emptyleg'}
            index={index}
            route={route}
            errors={errors[index] || []}
            airports={airports}
            dropDownParent={dropDownParent}
            onlyAirports={onlyAirports}
            maxAirports={maxAirports}
            onChangeRoute={handleChangeRoute}
            onRemove={removeRoute}
            onSearch={handleSearch}
            onFocus={() => onFocus && onFocus()}
        />)}

        {type === 'planes' && <div className="search-btns">
            {routes.length < maxRoutes && routes[routes.length - 1].from.id && routes[routes.length - 1].to.id &&
                <a href='#' className="search-button button-return" onClick={e => addRoute(e, routes.length - 1)}>
                    <i className="icon-return"></i> {tMsg('Обратный перелёт')}
                </a>}
            {routes.length < maxRoutes && <a href='#' className="search-button button-add" onClick={addRoute}>
                <i className="icon-way"></i> {tMsg('Добавить маршрут')}
            </a>}
            <button className="search-button button-search" onClick={() => handleSearch()}>
                <i className="icon-search2"></i> {tMsg('Поиск')}
            </button>
        </div>}

        {type === 'plane' && routes.length < maxRoutes && <div className="search-btns__request">
            <a href='#' className="button-add" onClick={addRoute}>
                <span>+</span> {tMsg('Добавить маршрут')}
            </a>
            {routes.length === 1 && routes[0].from.id && routes[0].to.id && <a href='#' className="button-add" onClick={e => addRoute(e, 0)}>
                <i className="icon-arrow4"/> {tMsg('Обратный перелёт')}
            </a>}
        </div>}
    </div>
}